import { Col, Row } from "antd";
import React from "react";
import BannerCard from "../common/components/BannerCard";
import Page from "../common/components/Page";
import Shortcut from "../common/components/Shortcut";
import getConfigs from "../GetConfigs";

const Home = () => {
  const configurations = getConfigs([
    "ctTRCRLookup",
    "ctCVLookup",
    "ctTRCRSchedQuery",
    "ctCVLSchedQuery",
    "ctActiveWarrantsPage",
    "cvEfilePage"
  ]);
  return (
    <Page>
      <Page.Title icon="home" title="Lookup Options" />
      <Page.Content>
        <Row gutter={[16, 16]}>
          {(configurations.ctTRCRLookup == "true" || configurations.ctCVLookup == "true") && (
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <BannerCard title="Case Lookup Options" styleInternal={true}>
                {configurations.ctTRCRLookup == "true" && (
                  <div>
                    <Shortcut name="Traffic/Criminal Case Lookup" icon="search" route="/lookup" />
                    <br />
                  </div>
                )}
                {configurations.ctCVLookup == "true" && (
                  <Shortcut name="Civil Case Lookup" icon="user" route="/civil" />
                )}
              </BannerCard>
            </Col>
          )}
          {(configurations.ctTRCRSchedQuery == "true" || configurations.ctCVLSchedQuery == "true") && (
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <BannerCard title="Case Schedule Query Options" styleInternal={true}>
                {configurations.ctTRCRSchedQuery == "true" && (
                  <div>
                    <Shortcut name="Traffic/Criminal Case Query" icon="search-plus" route="/tr-cr-query" />
                    <br />
                  </div>
                )}
                {configurations.ctCVLSchedQuery == "true" && (
                  <Shortcut name="Civil Case Query" icon="user-plus" route="/civil-query" />
                )}
              </BannerCard>
            </Col>
          )}
        </Row>
        {configurations.cvEfilePage == "true" &&
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <BannerCard title="New Cases" styleInternal={true}>
                <Shortcut name="File New Civil Case" icon="plus-square" route="/civil/new" />
                <br />
              </BannerCard>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              {/*<BannerCard title="Case Schedule Query Options" styleInternal={true}>*/}
              {/*  <Shortcut name="Traffic/Criminal Case Query" icon="search-plus" route="/tr-cr-query" />*/}
              {/*  <br />*/}
              {/*  <Shortcut name="Civil Case Query" icon="user-plus" route="/civil-query" />*/}
              {/*</BannerCard>*/}
            </Col>
          </Row>
        }
      </Page.Content>
    </Page>
  );
};

export default Home;
